import { Moon, Sun } from "lucide-react"
import { useTheme } from "@/components/theme-provider"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()

  // Resolve "system" theme to actual theme for icon display
  const effectiveTheme = theme === "system"
    ? (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light")
    : theme

  const isDark = effectiveTheme === "dark"

  const toggleTheme = () => {
    const toggle = () => {
      // Toggle between light and dark (skip system option)
      setTheme(isDark ? "light" : "dark")
    }

    // View Transitions API (Chrome 111+)
    if ('startViewTransition' in document) {
      (document as any).startViewTransition(() => {
        toggle()
      })
    } else {
      // Fallback: instant toggle (CSS handles transition)
      toggle()
    }
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      aria-label="Toggle theme"
      className="rounded-full hover:bg-accent hover:text-accent-foreground transition-colors duration-200"
    >
      <span className="sr-only">Toggle theme</span>
      {/* Sun icon - shown in dark mode */}
      <Sun
        className={cn(
          "h-[1.2rem] w-[1.2rem] transition-all duration-200 text-foreground",
          isDark ? "rotate-0 scale-100" : "rotate-90 scale-0"
        )}
      />
      {/* Moon icon - shown in light mode */}
      <Moon
        className={cn(
          "absolute h-[1.2rem] w-[1.2rem] transition-all duration-200 text-foreground",
          isDark ? "rotate-90 scale-0" : "rotate-0 scale-100"
        )}
      />
    </Button>
  )
}
